import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { GalleryRelatedOfficeModule } from './gallery-related-office/gallery-related-office.module';
import { GalleryViewDesktopComponent } from './gallery-view-desktop/gallery-view-desktop.component';
import { GalleryViewComponent } from './gallery-view.component';
import { ListingGalleryViewComponent } from "./listing-gallery-view/listing-gallery-view.component";
import { PaginationModule } from './pagination/pagination.module';

import { SelectModule } from '../forms/select/select.module';
import { LoaderModule } from '../loader/loader.module';
import { LogoModule } from '../logo/logo.module';
import { MainBreadCrumbsModule } from '../main-bread-crumbs/main-bread-crumbs.module';
import { PanelMessageModule } from '../panel-message/panel-message.module';

import { ListingCardModule } from '../../shared/components/listing-card/listing-card.module';
import { SharedDirectivesModule } from '../../shared/directives/shared-directives.module';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { ListingCardPlaceholderComponent } from '../listing-card-placeholder/listing-card-placeholder.component';
import { OfficeRelatedInfoPlaceholderComponent } from '../../office-related-info-placeholder/office-related-info-placeholder.component';
import { GallerySortComponent } from './gallery-sort/gallery-sort.component';

@NgModule({
    imports: [
        CommonModule,
        GalleryRelatedOfficeModule,
        InfiniteScrollModule,
        ListingCardModule,
        LoaderModule,
        LogoModule,
        MainBreadCrumbsModule,
        PaginationModule,
        PanelMessageModule,
        ReactiveFormsModule,
        SelectModule,
        SharedDirectivesModule,
        SharedPipesModule,
        TranslateModule.forChild()
    ],
    declarations: [
        GalleryViewComponent,
        GalleryViewDesktopComponent,
        ListingGalleryViewComponent,
        GallerySortComponent,
        ListingCardPlaceholderComponent,
        OfficeRelatedInfoPlaceholderComponent
    ],
    exports: [
        GalleryViewComponent,
        GalleryViewDesktopComponent,
        ListingGalleryViewComponent,
        GallerySortComponent,
        ListingCardPlaceholderComponent,
        OfficeRelatedInfoPlaceholderComponent
    ]
})
export class GalleryViewModule { }
